export enum ERozcestnikResponse {
    AMLZ = 'AMLZ',
    LEI = 'LEI',
    ISIN = 'ISIN',
    AMLZLEI = 'AMLZLEI',
    ISINLEI = 'ISINLEI',
    CEKA = 'CEKA',
    CEKALEI = 'CEKALEI'
}
